import { 
    BUSSINESS_SAVINGS_ACCOUNT_TYPE_SUBTYPE,
    CHECKING_ACCOUNT_OPEN_TYPE_SUBTYPE_NL,
    CHECKING_ACCOUNT_TYPE_SUBTYPE,
    CHECKING_ACCOUNT_TYPE_SUBTYPE_DE,
    CHECKING_ACCOUNT_TYPE_SUBTYPE_PT,
    CHECKING_CURRENCIES_ACCOUNT_TYPE_SUBTYPE, 
    CHECKING_HBF_ACCOUNT_TYPE_SUBTYPE, 
    CHECKING_PAYROLL_ACCOUNT_TYPE_SUBTYPE, 
    CHECKING_SPECIAL_ACCOUNT_TYPE_SUBTYPE, 
    DERIVATES_ACCOUNT_TYPE_SUBTYPE, 
    EASY_ACCOUNT_TYPE_SUBTYPE, 
    HOME_ACCOUNT_SAVINGS_TYPE_SUBTYPE, 
    MORE_OPEN_ACCOUNT_TYPE_SUBTYPE, 
    ONE_TWO_THREE_ACCOUNT, 
    OPEN_ACCOUNT_TYPE_SUBTYPE, 
    OPEN_PLUS_ACCOUNT_TYPE_SUBTYPE, 
    SAVINGS_ACCOUNT_TYPE_SUBTYPE, 
    SAVINGS_ACCOUNT_TYPE_SUBTYPE_NL, 
    SAVINGS_ACCOUNT_TYPE_SUBTYPE_PT, 
    SAVINGS_DAILY_ACCOUNT_TYPE_SUBTYPE_DE, 
    SAVINGS_DAILY_WELCOME_ACCOUNT_TYPE_SUBTYPE_DE, 
    SAVINGS_OPEN_YOUNG_ACCOUNT_TYPE_SUBTYPE, 
    SAVINGS_WELCOME_ACCOUNT_TYPE_SUBTYPE,
    SAVINGS_WELCOME_PAYROLL_ACCOUNT_TYPE_SUBTYPE,
    WELCOME_ACCOUNT_TYPE_SUBTYPE_PT,
    WELCOME_ACCOUNT_V_TYPE_SUBTYPE_NL
} from "../../constants/accounts";

const ACTION_CODE_ACCOUNT_CANCELATION_CHECKING = 192611155;
const ACTION_CODE_ACCOUNT_CANCELATION_SAVINGS = 192611154;
const ACTION_CODE_ACCOUNT_CANCELATION_OPEN_YOUNG = 192611162;
const ACTION_CODE_ACCOUNT_CANCELATION_PAYROLL = 192611156;
const ACTION_CODE_ACCOUNT_CANCELATION_WELCOME = 192611160;
const ACTION_CODE_ACCOUNT_CANCELATION_WELCOME_PAYROLL = 192611161;

export const getWrapUpOperationCode = (action, state, isFinalCode = false) => {
    const accountId = isFinalCode ? state.accountCancel.get('accountId') : action.split('/')[3];
    const account = state.accounts.get('byId').get(accountId);
    const accountType = `${account.get('newProduct')}${account.get('accountType')}`;
    let actionCode;
    switch (accountType) {
        // Savings Account Types
        case SAVINGS_ACCOUNT_TYPE_SUBTYPE:
        case SAVINGS_ACCOUNT_TYPE_SUBTYPE_NL:
        case SAVINGS_DAILY_ACCOUNT_TYPE_SUBTYPE_DE:
        case SAVINGS_ACCOUNT_TYPE_SUBTYPE_PT:
        case OPEN_ACCOUNT_TYPE_SUBTYPE:
        case BUSSINESS_SAVINGS_ACCOUNT_TYPE_SUBTYPE:
        case HOME_ACCOUNT_SAVINGS_TYPE_SUBTYPE:
        case OPEN_PLUS_ACCOUNT_TYPE_SUBTYPE:
        case MORE_OPEN_ACCOUNT_TYPE_SUBTYPE:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_SAVINGS;
            break;
        // Checking Account Types
        case CHECKING_CURRENCIES_ACCOUNT_TYPE_SUBTYPE:
        case CHECKING_SPECIAL_ACCOUNT_TYPE_SUBTYPE:
        case CHECKING_HBF_ACCOUNT_TYPE_SUBTYPE:
        case CHECKING_ACCOUNT_TYPE_SUBTYPE:
        case CHECKING_ACCOUNT_OPEN_TYPE_SUBTYPE_NL:
        case CHECKING_ACCOUNT_TYPE_SUBTYPE_DE:
        case CHECKING_ACCOUNT_TYPE_SUBTYPE_PT:
        case DERIVATES_ACCOUNT_TYPE_SUBTYPE:
        case EASY_ACCOUNT_TYPE_SUBTYPE:
        case ONE_TWO_THREE_ACCOUNT:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_CHECKING;
            break;
        // Payroll Account Types
        case CHECKING_PAYROLL_ACCOUNT_TYPE_SUBTYPE:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_PAYROLL;
            break;
        // Welcome Account Types
        case SAVINGS_WELCOME_ACCOUNT_TYPE_SUBTYPE:
        case WELCOME_ACCOUNT_TYPE_SUBTYPE_PT:
        case WELCOME_ACCOUNT_V_TYPE_SUBTYPE_NL:
        case SAVINGS_DAILY_WELCOME_ACCOUNT_TYPE_SUBTYPE_DE:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_WELCOME;
            break;
        // Welcome Payroll Account Types
        case SAVINGS_WELCOME_PAYROLL_ACCOUNT_TYPE_SUBTYPE:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_WELCOME_PAYROLL;
            break;
        // Open Young Account Types
        case SAVINGS_OPEN_YOUNG_ACCOUNT_TYPE_SUBTYPE:
            actionCode = ACTION_CODE_ACCOUNT_CANCELATION_OPEN_YOUNG;
            break;
        default:
            break;
    }
    return actionCode;
}